import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetFareConditionsEffect } from './get-fare-conditions.effect';
import { getFareConditionsReducer } from './get-fare-conditions.reducer';
import { GET_FARE_CONDITIONS_STORE_NAME, GetFareConditionsState } from './get-fare-conditions.state';

/** Token of the GetFareConditions reducer */
export const GET_FARE_CONDITIONS_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetFareConditionsState, Action>>(
  'Feature GetFareConditions Reducer'
);

/** Provide default reducer for GetFareConditions store */
export function getDefaultGetFareConditionsReducer() {
  return getFareConditionsReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_FARE_CONDITIONS_STORE_NAME, GET_FARE_CONDITIONS_REDUCER_TOKEN),
    EffectsModule.forFeature([GetFareConditionsEffect]),
  ],
  providers: [{ provide: GET_FARE_CONDITIONS_REDUCER_TOKEN, useFactory: getDefaultGetFareConditionsReducer }],
})
export class GetFareConditionsStoreModule {
  public static forRoot<T extends GetFareConditionsState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetFareConditionsStoreModule> {
    return {
      ngModule: GetFareConditionsStoreModule,
      providers: [{ provide: GET_FARE_CONDITIONS_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
